module.exports = __webpack_public_path__ + "static/media/North grove 4.8f7a7b76.jpg";